import React from "react";

interface Props {
  paused: boolean;
  onToggle: () => void;
  className?: string;
}

// Stops and restarts a row of scrolling names (the tutor casts on the home
// and About pages), so they can be read, or stilled, without a mouse.
// Hidden where reduced motion already holds them still.
const MarqueePauseButton: React.FC<Props> = ({ paused, onToggle, className }) => (
  <button
    type="button"
    className={`marquee-pause${className ? ` ${className}` : ""}`}
    aria-label={paused ? "Play the scrolling tutor names" : "Pause the scrolling tutor names"}
    onClick={onToggle}
  >
    {paused ? (
      <svg aria-hidden="true" viewBox="0 0 24 24">
        <path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.5-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5z" />
      </svg>
    ) : (
      <svg aria-hidden="true" viewBox="0 0 24 24">
        <rect x="6" y="5" width="4" height="14" rx="1" />
        <rect x="14" y="5" width="4" height="14" rx="1" />
      </svg>
    )}
    <span>{paused ? "Play" : "Pause"}</span>
  </button>
);

export default MarqueePauseButton;
